// Copyright (c) 2025 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { t } from "@lingui/macro"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Slice from "../slices/timeline"
import * as Actions from "../actions"
import { showSnackBar } from "../../snackbar/actions"
import { from, Init, timesheetFieldService } from "../../../app/rpc"
import {
  ListFavouriteTimesheetFieldOptionsResponse,
  RemoveFavouriteTimesheetFieldOptionRequestSchema,
} from "../../../generated/wisetime/site/timesheetfield/v1/timesheet_field_pb"

type RemoveFavouriteTimesheetFieldOptionRpc = (request: Init<typeof RemoveFavouriteTimesheetFieldOptionRequestSchema>) => Observable<ListFavouriteTimesheetFieldOptionsResponse>

export const removeFavouriteTimesheetFieldOption = (removeFavouriteTimesheetFieldOptionRpc: RemoveFavouriteTimesheetFieldOptionRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.removeFavouriteTimesheetFieldOption.match),
      mergeMap((action) => removeFavouriteTimesheetFieldOptionRpc(action.payload)
        .pipe(
          map(response => ({
            siteId: action.payload.siteId ?? "",
            options: response.timesheetFieldOptions,
          })),
          map(Slice.setFavouriteTimesheetFieldOptions),
          catchError(() => of(showSnackBar({
            message: t({
              id: "msg_remove_favourite_timesheet_field_option_failed",
              message: "Failed to unfavourite timesheet field option. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com.",
            }),
            messageType: "ERROR",
          }))),
        )
      ),
    )

const removeFavouriteTimesheetFieldOptionRpc = (request: Init<typeof RemoveFavouriteTimesheetFieldOptionRequestSchema>): Observable<ListFavouriteTimesheetFieldOptionsResponse> =>
  from(() => timesheetFieldService.removeFavouriteTimesheetFieldOption(create(RemoveFavouriteTimesheetFieldOptionRequestSchema, request)))

export default removeFavouriteTimesheetFieldOption(removeFavouriteTimesheetFieldOptionRpc)
